<template>
    <div>
        <v-form ref="form">
            <v-container>
                <v-layout wrap>
                    <v-flex md5 sm12>
                        <v-text-field
                                v-model="data.name"
                                append-icon="edit"
                                label="Name"
                                :rules="[rules.required]"
                                single-line
                                hide-details
                        ></v-text-field>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex md1>
                        <v-btn color="primary" dark class="mb-2" @click='save' :loading="loading">Save</v-btn>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-form>
        <div id='map'>
        </div>

    </div>
</template>

<script>
    import Mapbox from "mapbox-gl";
    import '@mapbox/mapbox-gl-draw/dist/mapbox-gl-draw.css'

    export default {
        name: "LandmarkEditor",
        title: 'Landmark Editor',
        data() {
            return {
                mode: "add", // or edit
                id: null,
                map: null,
                loading: false,
                answer: null,
                center: null,
                marker: null,
                data: {
                    name: null,
                }
            }
        },
        mounted() {
            Mapbox.accessToken = this.api.mapBox.accessToken;
            this.center = this.api.mapBox.center;
            this.marker = new Mapbox.Marker({draggable: true});
            this.marker.setLngLat(this.api.mapBox.center);
            if (this.$route.params.id !== undefined) {
                this.mode = "edit";
                this.id = this.$route.params.id;
                this.getData();
            } else {
                this.mode = "add";
                this.loadMap();
            }
        },
        methods: {
            loadMap() {
                this.map = new Mapbox.Map(Object.assign({container: 'map',},
                    this.api.mapBox,
                    {center: this.center}
                ));
                this.marker.addTo(this.map);
            },
            getData() {
                this.axios.get(this.api.ACTIONS.LANDMARKS + `/${this.id}`).then(
                    ({data}) => {
                        const {name, centroid} = data.data;
                        this.marker.setLngLat(centroid.coordinates);
                        this.loadMap();
                        this.data.name = name;
                    }
                )
            },

            reset() {
                this.data.name = null;
            },
            save() {
                if (!this.loading && this.$refs.form.validate()) {
                    this.loading = true;
                    const url = this.mode === "add" ? this.api.ACTIONS.LANDMARKS : this.api.ACTIONS.LANDMARKS + "/" + this.id;
                    (this.mode === "add" ? this.axios.post : this.axios.put)(url, {
                        centroid: {
                            type: 'Point',
                            coordinates: this.marker.getLngLat().toArray()
                        }, ...this.data
                    }).then(
                        () => {
                            window.getApp.$emit("SHOW_TOAST", "Saved!", "green");
                            this.mode === "add" ? this.reset() : null;
                        }
                    ).catch(
                        () => window.getApp.$emit("SHOW_TOAST", "Not Saved", "red")
                    ).finally(
                        () => this.loading = false
                    )
                }
            }
        },
        computed: {
            rules: () => ({
                required: value => !!value || 'Required.',
                number: value => isFinite(value) || 'Must be number'
            })
        }
    }
</script>


<style scoped>

    #map {
        width: 100%;
        height: 720px;
    }
</style>

<style scoped>

</style>